const initialState = {
    locations: [],
    projects: [],
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'JIRA_PROJECTS_SUCCESS') {
        return { ...state, projects: action.payload };
    }

    if (action.type === 'JIRA_LOCATIONS_SUCCESS') {
        return { ...state, locations: action.payload };
    }

    return state;
}

export default reducer;
